export const autoFlaggedScoreCategoriesQueryKeys = {
  all: ['autoFlaggedScoreCategories'] as const,
  lists: () => [...autoFlaggedScoreCategoriesQueryKeys.all, 'list'] as const,
  list: () => [...autoFlaggedScoreCategoriesQueryKeys.lists()] as const,
  usage: (categoryId: string) => [...autoFlaggedScoreCategoriesQueryKeys.all, 'usage', categoryId] as const,
}
